<template>
  <div v-if="confirmRequestDetails">
    <div class="media align-items-center mt-2">
      <img
        class="rounded-circle user-image border mr-2"
        :src="getPhoto(confirmRequestDetails.form.company.logo,'thumbnailCropped')"
        alt=""
        style="width: 60px"
      >
      <div class="about">
        <div class="name f-w-600">
          {{ confirmRequestDetails.form.company.name }} {{ getCompanyFormat(confirmRequestDetails.form.company.format) }}
        </div>
        <div class="status">
          {{ confirmRequestDetails.form.company.taxId }}
        </div>
      </div>
    </div>

    <form
      v-if="confirmRequestDetails.form.profileType==='SUPPLIER'"
      @submit.prevent="submitConfirmRequestForm"
    >
      <div class="mb-2 lead">
        {{ $t('confirmVendorRequestModal.irktiTsdiqlnmiTdarkKimiLavEtmkIstdiyinizFaliyytSah') }}
      </div>

      <label
        v-for="s in confirmRequestDetails.sectors"
        class="d-block"
      >

        <input
          v-model="confirmRequestSectors"
          class="checkbox_animated"
          :disabled="confirmRequestDetails.selectedSectors.indexOf(s.id+'')<0"
          type="checkbox"
          :value="s.id"
        >
        <span :class="{'disabled':confirmRequestDetails.selectedSectors.indexOf(s.id+'')<0 }">{{ s.name }} </span>
      </label>

      <div class="my-2">
        <button
          class="btn btn-success"
          type="submit"
        >
          {{ $t('login.tsdiql') }}
        </button>
      </div>
    </form>

    <form
      v-else
      @submit.prevent="submitConfirmRequestForm"
    >
      <div class="mb-2 lead">
        {{ $t('confirmVendorRequestModal.irktiTsdiqlnmiTdarkKimiLavEtdiyinizHaldaSizinBtnLo') }}
      </div>

      <div class="my-2">
        <button
          class="btn btn-lg btn-success"
          type="submit"
        >
          {{ $t('login.tsdiql') }}
        </button>
      </div>
    </form>
  </div>
</template>
<script>
import {getCompanyFormat, getPhoto} from "@/repositories/Utils";
import {approveRequest, handleErrors} from "@/repositories/VendorManagementRepository";
import {mapState} from "vuex";

export default {
  name: 'ConfirmVendorRequestModal',
  props: {
    confirmRequestDetails: null,
  },
  data() {
    return {
      confirmRequestSectors: []
    };
  },

  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
    }),
  },
  created(){
    this.confirmRequestSectors = this.confirmRequestDetails.selectedSectors;
  },
  methods: {
    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },

    getPhoto(path, size) {
      return getPhoto(path, size);
    },


    submitConfirmRequestForm() {

      if (this.confirmRequestSectors.length < 1 && this.confirmRequestDetails.form.profileType==='SUPPLIER') {
        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          text: this.$t("mnmm1FlyytShsScmlsnz"),
          icon: 'warning'
        })
      } else {

        approveRequest(this.token, this.confirmRequestDetails.requestId, this.confirmRequestSectors.join(','))
            .then(({code, id, message, errorCode}) => {
              if (code === 200) {
                this.$swal({
                  title: this.$t("generalModal.successTitle"),
                  text: this.$t("mrctTsdqlnd"),
                  icon: 'success'
                }).then(() => {
                  this.$bvModal.hide('modal-request-confirm');
                  this.$emit('updated');
                });

              } else if (code === 404) {
                this.$swal({
                  title: this.$t("general.notFound"),
                  text: this.$t("axtrdgnzFrmTpldm"),
                  icon: 'error'
                }).then(() => {
                })
              } else {
                handleErrors(this.$swal, data,null);
              }
            })
      }
    },
  }
}
</script>
